




import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroGameDocument } from "@/services/datatypes";
import { collectionName } from "@/services/collection-name";
import { firestore, db } from "@/scripts/firebase";
import { NextPlayQueueParams } from "@/services/paramstypes";
import { DialogProgrammatic as Dialog } from "buefy";

@Component({
  components: {}
})
export default class ProceedPlayButton extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly jinroGame!: JinroGameDocument;

  handleProceedPlay() {
    Dialog.confirm({
      message: `本当に次に進みますか？`,
      cancelText: "キャンセル",
      confirmText: "進める",
      onConfirm: async () => this.proceedPlay()
    });
  }

  async proceedPlay() {
    if (!this.jinroGame || !this.jinroGame.currentJinroPlayinfoId) {
      return;
    }
    // update jinroGame
    await db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .set(
        {
          isNextPlayQueueProcessing: true,
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        {
          merge: true
        }
      );

    // create new queue
    const nextPlayqueueParams: NextPlayQueueParams = {
      finishedJinroPlayId: this.jinroGame.currentJinroPlayinfoId,
      jinroGameId: this.jinroGameId,
      isProcessed: false,
      timeCreated: firestore.FieldValue.serverTimestamp()
    };
    await db.collection(collectionName.nextplayqueues).add({
      ...nextPlayqueueParams
    });

    return;
  }
}
